import { inject, Injectable } from '@angular/core';
import { IRuntimeConfig } from '@redngapps/feature-flags/env/types';
import { AbstractRuntimeConfigInitializerService } from '@redngapps/shared/runtime-config/data-access';

import { RuntimeConfigService } from './runtime-config.service';

/**
 * Loads `/assets/runtime-config.json` on app start and wires the instance server credentials. The
 * load/parse/fallback logic lives in the shared base; here we only bind the concrete config service.
 */
@Injectable({ providedIn: 'root' })
export class RuntimeConfigInitializerService extends AbstractRuntimeConfigInitializerService<IRuntimeConfig> {
  protected readonly configService = inject(RuntimeConfigService);
}
